// Constants
export const ORIGIN_LOCAL = 'local';
export const ORIGIN_REMOTE = 'remote';
export const ORIGIN_CACHE_REPLAY = 'cache-replay';
export const SNAPSHOT_INTERVAL_MS = 2000; // Save snapshot if idle for 2 seconds
export const MAX_REMOTE_VERSION_HASH_LIST = 5;
export const PRESENCE_THROTTLE_MS = 50; // 20Hz throttle rate
export const USER_ACTIVITY_TIMEOUT_MS = 1000; // Consider user inactive after 1 second of no activity (for painting remote updates)
